(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.api.async'

  require('angular')
    .module(MODULE_NAME, [
      require('./api')
    ])
    .factory('ThismomentAsyncApi', asyncApi)

  asyncApi.$inject = ['ThismomentApi']
  function asyncApi (ThismomentApi) {
    var ThismomentAsyncApi = {
      configureResource: configureResource
    }

    return ThismomentAsyncApi

    // TODO: Allowing actions or options as definable parameters is probably overengineering...
    function configureResource (url, params, actions, options) {
      var API = ThismomentApi.configureResource(url, params, actions, options)
      var Client = {
        delete: deleteAsync,
        get: getAsync,
        getAll: getAllAsync,
        patch: patchAsync,
        post: postAsync,
        save: saveAsync,
        update: updateAsync
      }

      return Client

      function deleteAsync (params, onSuccess, onError) {
        return API.delete(params).$promise
          .then(function deleteAsyncResolve (response) {
            return asyncApiWin(response, onSuccess)
          })
          .catch(function deleteAsyncReject (reason) {
            return asyncApiFail(reason, onError)
          })
      }

      function getAsync (params, onSuccess, onError) {
        return API.get(params).$promise
          .then(function getAsyncResolve (response) {
            return asyncApiWin(response, onSuccess)
          })
          .catch(function getAsyncReject (reason) {
            return asyncApiFail(reason, onError)
          })
      }

      // TODO: Replace 'getAllAsync' with 'getAsync' throughout whole app
      function getAllAsync (onSuccess, onError) {
        return API.get().$promise
          .then(function getAllAsyncResolve (response) {
            return asyncApiWin(response, onSuccess)
          })
          .catch(function getAllAsyncReject (reason) {
            return asyncApiFail(reason, onError)
          })
      }

      // TODO: Replace 'saveAsync' with 'postAsync' throughout whole app
      function saveAsync (formData, onSuccess, onError) {
        return API.save({}, formData).$promise
          .then(function saveAsyncResolve (response) {
            return asyncApiWin(response, onSuccess)
          })
          .catch(function saveAsyncReject (reason) {
            return asyncApiFail(reason, onError)
          })
      }

      function postAsync (params, formData, onSuccess, onError) {
        return API.post(params, formData).$promise
          .then(function postAsyncResolve (response) {
            return asyncApiWin(response, onSuccess)
          })
          .catch(function postAsyncReject (reason) {
            return asyncApiFail(reason, onError)
          })
      }

      // TODO: Replace 'updateAsync' with 'patchAsync' throughout whole app
      function updateAsync (id, formData, onSuccess, onError) {
        return API.update({id: id}, formData).$promise
          .then(function updateAsyncResolve (response) {
            return asyncApiWin(response, onSuccess)
          })
          .catch(function updateAsyncReject (reason) {
            return asyncApiFail(reason, onError)
          })
      }

      function patchAsync (params, formData, onSuccess, onError) {
        return API.update(params, formData).$promise
          .then(function patchAsyncResolve (response) {
            return asyncApiWin(response, onSuccess)
          })
          .catch(function patchAsyncReject (reason) {
            return asyncApiFail(reason, onError)
          })
      }

      function asyncApiWin (response, callback) {
        if (angular.isFunction(callback)) {
          callback(response)
        }
        return response.data
      }

      function asyncApiFail (reason, callback) {
        if (angular.isFunction(callback)) {
          callback(reason)
        }
        return reason
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/api/async.js